module.exports = __webpack_public_path__ + "img/changshin-top-logo.a54f5af8.png";